import { FooterProps } from '../@types/FooterProps';
import { useFooter } from '../hooks/useFooter';

const FooterLayout = ({ children, blockClass }: FooterProps) => {
	const { componentId } = useFooter();
	return (
		<div data-selection={componentId} data-hydration-id="store.home/$after_footer" style={{ display: 'contents' }}>
			<div className="vtex-store-footer-2-x-footerLayoutSpacer footerLayoutSpacer flex flex-grow-1"></div>
			<div
				className={`vtex-store-footer-2-x-footerLayout footerLayout vtex-store-footer-2-x-footerLayout--${blockClass} footerLayout--${blockClass}`}
			>
				{children}
			</div>
		</div>
	);
};

export default FooterLayout;
